import React from 'react';
import PropTypes from 'prop-types';

const Address = ({team, linked = false}) => {
    const leagueAddresses = () => {
        // The NY office arena name is 'Corporate Office'. We don't want that to show or be part of the query for
        // the maps link -  so we just use the same thing as 'teamArenaAddress' without the name.
        const NewYorkNHLOffice = `${team.arenaAddress}, ${team.arenaAddress2}, ${team.arenaCity}, ${team.arenaStateProvince} ${team.arenaZipPostalCode}`;
        const TorontoNHLOfficeAddress = '50 Bay St., Toronto, ON M5J 2X8';
        const MontrealNHLOfficeAddress = '1800 McGill College Ave., Montréal, QC H3A 3J6';

        return (
            <div className="addresses">
                <div className="address-header">New York Office</div>
                {linked
                    ? <a href={`http://maps.apple.com?q=${NewYorkNHLOffice}`} target="_blank">{NewYorkNHLOffice}</a>
                    : <span>{NewYorkNHLOffice}</span>
                }
                <div className="address-header">Toronto Office</div>
                {linked
                    ? <a href={`http://maps.apple.com?q=${TorontoNHLOfficeAddress}`}
                         target="_blank">{TorontoNHLOfficeAddress}</a>
                    : <span>{TorontoNHLOfficeAddress}</span>
                }
                <div className="address-header">Montréal Office</div>
                {linked
                    ? <a href={`http://maps.apple.com?q=${MontrealNHLOfficeAddress}`}
                         target="_blank">{MontrealNHLOfficeAddress}</a>
                    : <span>{MontrealNHLOfficeAddress}</span>
                }
            </div>
        );
    };

    const teamAddresses = () => {
        const teamOfficeAddress = team.officeAddress2 !== null
            ? `${team.officeAddress}, ${team.officeAddress2}, ${team.officeCity}, ${team.officeStateProvince} ${team.officeZipPostalCode}`
            : `${team.officeAddress}, ${team.officeCity}, ${team.officeStateProvince} ${team.officeZipPostalCode}`;

        if(!team.arenaAddress || team.arenaAddress === team.officeAddress2) {
            return (
                <div className="addresses">
                    {linked
                        ? <a href={`http://maps.apple.com?q=${teamOfficeAddress}`} target="_blank">{teamOfficeAddress}</a>
                        : <span>{teamOfficeAddress}</span>
                    }
                </div>
            )
        }  else {
            const teamArenaAddress = `${team.arenaName}, ${team.arenaAddress}, ${team.arenaCity}, ${team.arenaStateProvince} ${team.arenaZipPostalCode}`;

            return (
                <div className="addresses">
                    <div className="address-header">Arena Address</div>
                    {linked
                        ? <a href={`http://maps.apple.com?q=${teamArenaAddress}`} target="_blank">{teamArenaAddress}</a>
                        : <span>{teamArenaAddress}</span>
                    }
                    <div className="address-header">Office Address</div>
                    {linked
                        ? <a href={`http://maps.apple.com?q=${teamOfficeAddress}`} target="_blank">{teamOfficeAddress}</a>
                        : <span>{teamOfficeAddress}</span>
                    }
                </div>
            )
        }
    };

    return (
        team.id === 99 ? leagueAddresses() : teamAddresses()
    )
};

Address.propTypes = {
    team: PropTypes.shape({
        arenaName: PropTypes.string,
        arenaAddress: PropTypes.string,
        arenaCity: PropTypes.string,
        arenaStateProvince: PropTypes.string,
        arenaZipPostalCode: PropTypes.string,
        officeAddress: PropTypes.string,
        officeAddress2: PropTypes.string,
        officeCity: PropTypes.string,
        officeStateProvince: PropTypes.string,
        officeZipPostalCode: PropTypes.string
    })
};

export default Address;